import { render } from "./pod-metric.vue?vue&type=template&id=a8005d96"
import script from "./pod-metric.vue?vue&type=script&lang=js"
export * from "./pod-metric.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__